import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MemberService } from '../member-service/MemberService ';

@Component({
  selector: 'app-blood-report-analyses',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatPaginatorModule, MatPaginator, MatProgressSpinnerModule],
  templateUrl: './blood-report-analyses.component.html',
  styleUrl: './blood-report-analyses.component.css'
})
export class BloodReportAnalysesComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['reportGeneratedAt', 'labBloodReport', 'bloodReportAnalysisUrl'];
  memberId: string = '';
  firstPage: number = 0;
  pageSize: number = 5;
  pageIndex: number = 0;
  totalRecords: number = 0;
  isLoading: boolean = false;

  constructor(
    private memberService: MemberService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.memberId = this.route.snapshot.queryParamMap.get('id') || '';
    if (this.memberId) {
      this.getBloodReports(1);
    }
  }

  getBloodReports(pageNo: number): void {
    this.isLoading = true;
    this.memberService.getMemberBloodReport(this.memberId, pageNo, this.pageSize).subscribe({
      next: (data: any) => {
        if (!data || !data.result) {
          this.dataSource = new MatTableDataSource<any>([]);
          this.totalRecords = 0;
          this.pageIndex = pageNo - 1;
          this.isLoading = false;
          return;
        }

        // API shape:
        // {
        //   result: {
        //     memberId,
        //     timezone,
        //     bloodReports: [...]
        //   },
        //   totalCount: number
        // }
        const pageItems = data.result.bloodReports || [];
        this.dataSource = new MatTableDataSource<any>(pageItems);
        this.totalRecords = data.totalCount ?? pageItems.length;
        this.pageIndex = pageNo - 1;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching blood reports:', error);
        this.isLoading = false;
      }
    });
  }

  pageChangeEvent(page: any): void {
    this.getBloodReports(page.pageIndex + 1);
  }

  viewLabBloodReport(pdfFile: { pdfData?: string; contentType?: string }): void {
    const base64Data = pdfFile?.pdfData;
    if (!base64Data) {
      return;
    }

    // Convert base64 to blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: pdfFile.contentType || 'application/pdf' });

    // Create object URL and open in new tab
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');

    // Clean up the object URL after a delay to allow the file to load
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);
  }


  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const datePart = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    const timePart = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true });

    return `${datePart} at ${timePart}`;
  }
}
